<template>
  <div  class="three-steps">
      <div style="" class="border-top">
          <img src="@/assets/border.png" alt="Borde" srcset="" style="">
      </div>
      
      <h1 class="three-title" style="color:#00d371">TE LO EXPLICAMOS EN 3 PASOS:</h1>
        <div class="md-layout mt-4 ">
            <div class="md-layout-item md-size-15 md-small-size-100 mt-4">
                <div class="three-circle-white">
                    <img style="display: inline; width: 100%;" src="@/assets/01.png" alt="samimetrics calcula tu huella">
                    <span class="inner-circle-white-three"> 1</span>
                </div>
            </div>
            <div class="md-layout-item">
                <h1 class="three-title">Calcula</h1>
                <p class="parra-three">Calcula la huella de carbono de tu empresa, así podrás conocer cuáles son las fuente de emisiones. Para este ejemplo utilizaremos a una organización con una huella de carbono anual de <strong>100 toneladas de co2.</strong> 
                </p>
            </div>
        </div>
        <div class="md-layout mt-2" >
            <div class="md-layout-item md-size-15 md-small-size-100 mt-4">
                <div class="three-circle-white mt-2">
                    <img style=" width: 100%;" src="@/assets/02.png" alt="sello sustentable reduce">
                    <span class="inner-circle-white-three"> 2</span>
                </div>
            </div>
            <div class="md-layout-item">
                <h1 class="three-title"> Reduce</h1>
                <p class="parra-three"> Al saber cómo se compone la huella de carbono, se deben implementar planes de reducción de emisiones, por ejemplo con planes de eficiencia energética o energía renovable. Continuando con el ejemplo anterior, la organización logra reducir <strong>20 toneladas de co2.</strong> 
                </p>
            </div>
        </div>
        <div class="md-layout mt-2 ">
            <div class="md-layout-item md-size-15 md-small-size-100 mt-4">
                <div class="three-circle-white mt-2" style="background-color: #00d371;">
                    <img style="width: 50%; margin-top: 1rem;" src="@/assets/03-white.png" alt="sello sustentable neutraliza tu huella">
                    <span class="inner-circle-white-three" style="background-color: #00d371; color:white;"> 3</span>
                </div>
            </div>
            <div class="md-layout-item">
                <h1 class="three-title">Neutraliza</h1>
                 <p class="parra-three">Las emisiones que no se pudieron reducir, se neutralizan apoyando proyectos de reducción de emisiones a través del sistema de compensación de bonos de carbono. Continuando con el ejemplo se deben compensar <strong> 80 toneladas de co2</strong>  mediante bonos de carbono de proyectos de energía renovables, entre otros.</p>
            </div>
        </div>
        <div class="md-layout mt-2 ">
            <div class="md-layout-item md-size-15 md-small-size-100 three-circles-container" style="position: relative;">
                <div class="circle-1">
                    <img style="width: 100%; positon: relative;" src="@/assets/03-white.png" alt="sello sustentable neutraliza tu huella">
                </div>
                <div class="circle-2">
                    <img style="display: inline" src="@/assets/01.png" alt="samimetrics calcula tu huella">
                </div>
                <div class="circle-3">
                    <img style=" width: 100%;" src="@/assets/02.png" alt="sello sustentable reduce">
                </div>
            </div>
            <div class="md-layout-item">
                <p class="parra-three"><strong>Este proceso aplica tanto para productos, servicios, eventos y organizaciones.</strong> </p>
                <h1 class="three-title">El objetivo</h1>
                 <p class="parra-three">de todas las empresas debe estar enfocado en implementar estrategias para reducir sus emisiones, de esta forma cumplimos con las prácticas sustentables y ser una empresa carbono neutral.</p>
            </div>
        </div>
        <div style="position: relative; width: 100%; height: 4vw;">
          <img src="@/assets/border-left.png" alt="Borde izquierdo" srcset="" class="border-left-graph">
        </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
.border-top {
    position: relative; 
    width: 100%; 
    height: 4vw;
}
.border-top img {
    position: absolute; 
    top: -48%; 
    right: -18%; 
    width: 35%;
}
.three-steps {
    background-color: #f2f2f2; 
    text-align: justify; 
    padding: 2vw 13vw 2vw 13vw;
}
.inner-circle-white-three {
    background-color: #ffffff;
    border-radius: 100%;
    height: 4vw;
    width: 4vw;
    position:absolute;
    display: inline-block;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
    top: -30%;
    left: 0%;
    color: #00d371;
    font-weight: bold;
    text-align: center;
    font-size: 2vw;
    padding-top: 1.2vw;
}
.three-circle-white {
    width: 8vw;
    height: 8vw;
    background-color: #ffffff;
    border-radius: 100%;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    position: relative;
    text-align: center;
    padding: 0.2rem;
}

.mt-4 {
    margin-top: 4rem;
}
.mt-2 {
    margin-top: 2rem;
}
.three-title {
    font-size: 3.6vw;
    color: #707070
}
.parra-three {
    font-size: 1.6vw;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.75;
    letter-spacing: normal;
}

.circle-1 {
    width: 7vw;
    height: 7vw;
    border-radius: 100%;
    background-color: #00d371;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 23%;
    right: 20%;
    z-index: 2;
    text-align: center;
    padding: 1.5rem;
    padding-top: 1rem;
}
.circle-2 {
    width: 7vw;
    height: 7vw;
    border-radius: 100%;
    background-color: #ffffff;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 23%;
    left: -33%;
}

.circle-3 {
    width: 7vw;
    height: 7vw;
    border-radius: 100%;
    background-color: #ffffff;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    bottom:16%;
    right: 46%;
}

.border-left-graph {
    position: absolute; 
    bottom: -400%; 
    left: -18%; 
    width: 35%; 
    transform: rotate(180deg);
}
</style>